import styled from 'styled-components';
import { MTextBlockSimpleAlignment } from './MTextBlockSimple.types';

export const Wrapper = styled.div<{
  alignment: MTextBlockSimpleAlignment;
}>`
  display: flex;
  flex-direction: column;
  text-align: ${({ alignment }) => (alignment === MTextBlockSimpleAlignment.Center ? 'center' : 'left')};
`;
